import { Component, inject } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { TranslateService } from '@ngx-translate/core';
import { Permission } from 'src/app/common/enums';
import { AuthService } from 'src/app/core/authentication/auth.service';

export enum WorkerAgreementListType {
  WorkerAgreements = 1,
  EmploymentConditionsConfirmations = 2,
  MandateAgreementWorkedDays = 3,
}

@Component({
  selector: 'app-worker-agreement-list-tabs-container',
  templateUrl: './worker-agreement-list-tabs-container.component.html',
  styleUrls: ['./worker-agreement-list-tabs-container.component.scss'],
  standalone: false
})
export class WorkerAgreementListTabsContainerComponent {
  private translate = inject(TranslateService);
  private authService = inject(AuthService);

  listType: WorkerAgreementListType = this.getInitialListType();
  listTypes = WorkerAgreementListType;
  public readonly mandateAgreementWorkedDayListPermissions: Permission[] = [Permission.ViewAllMandateAgreementWorkedDays, Permission.ViewMyExternalWorkerMandateAgreementWorkedDays];
  public readonly splitComponentId = 'WorkerAgreementListTabsContainerComponent';


  constructor() {
  }

  hasPermissionToEmploymentConditionsConfirmations(): boolean {
    return this.authService.hasPermission(Permission.ViewMyExternalWorkerEmploymentConditionsConfirmation) || this.authService.hasPermission(Permission.ViewAllExternalWorkerEmploymentConditionsConfirmation);
  }

  hasPermissionToMandateAgreementWorkedDayList(): boolean {
    return this.authService.hasAnyPermission(this.mandateAgreementWorkedDayListPermissions);
  }

  onTabChanged(event: MatTabChangeEvent): void {
    const map = new Map<string, WorkerAgreementListType>([
      [this.translate.instant('WL-WorkerAgreement'), WorkerAgreementListType.WorkerAgreements],
      [this.translate.instant('EmploymentConditionsConfirmationList.EmploymentConditionsConfirmationList'), WorkerAgreementListType.EmploymentConditionsConfirmations],
      [this.translate.instant('MandateAgreementWorkedDayList.MandateAgreementWorkedDayList'), WorkerAgreementListType.MandateAgreementWorkedDays]
    ]);

    if (!map.has(event.tab.textLabel)) {
      return;
    }

    const index = map.get(event.tab.textLabel);

    this.listType = index;
  }

  private getInitialListType() {
    return WorkerAgreementListType.WorkerAgreements;
  }
}
